export default __webpack_public_path__ + "static/media/3.d8ae23e1.jpeg";